/**
 * Kept free of SDK imports so scripts (dashboard sync) can read it without
 * loading `@sentry/nextjs`.
 */
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export type MetricDefinition = {
	attributes: readonly string[];
	type: "count" | "distribution" | "gauge";
	unit?: "byte" | "millisecond";
};

/**
 * Every metric the app emits. Declared attributes are the ones dashboards
 * group by. Tenant, user and request ids are added by the SDK from the scope
 * (see spec "Attribute rules"), so don't declare them here.
 */
export const METRIC_DEFINITIONS = {
	"agent.dispatch": { attributes: ["mode", "outcome"], type: "count" },
	"auth.otp": { attributes: ["step", "outcome"], type: "count" },
	"automation.trigger": { attributes: ["outcome"], type: "count" },
	"client.network_failure": { attributes: [], type: "count" },
	"grpc.call.duration": {
		attributes: ["method", "target", "outcome", "grpc_status"],
		type: "distribution",
		unit: "millisecond",
	},
	"inbound.received": { attributes: ["source", "outcome"], type: "count" },
	"integration.connect": { attributes: ["provider", "outcome"], type: "count" },
	"scheduler.run.duration": {
		attributes: ["job", "outcome"],
		type: "distribution",
		unit: "millisecond",
	},
	"tasks.handle.duration": {
		attributes: ["task", "outcome", "retry"],
		type: "distribution",
		unit: "millisecond",
	},
} as const satisfies Record<string, MetricDefinition>;
